import { get, post } from './http';

export type ReviewStatus = 'pending' | 'approved' | 'rejected';
export type ReviewActionType = 'create' | 'edit' | 'delete';
export type ReviewScope = 'all' | 'mine';

export interface ReviewRequestItem {
  id: number;
  requesterUserId: number;
  requesterName: string;
  actionType: ReviewActionType;
  moduleKey: string;
  targetText: string;
  descriptionText: string;
  payloadJson: Record<string, unknown>;
  status: ReviewStatus;
  reviewedByUserId: number | null;
  reviewedByName: string | null;
  reviewedAt: string | null;
  rejectReason: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  canReview: boolean;
  isMine: boolean;
}

export interface ReviewRequestListResult {
  scope: ReviewScope;
  list: ReviewRequestItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ReviewRequestStats {
  scope: ReviewScope;
  total: number;
  pending: number;
  approved: number;
  rejected: number;
}

export interface ListReviewRequestsParams {
  status?: 'all' | ReviewStatus;
  moduleKey?: string;
  keyword?: string;
  scope?: ReviewScope;
  page?: number;
  pageSize?: number;
}

export function listReviewRequests(params?: ListReviewRequestsParams) {
  return get<ReviewRequestListResult>('/admin/review-requests', params ? { params } : undefined);
}

export function getReviewRequestStats(scope: ReviewScope = 'all') {
  return get<ReviewRequestStats>('/admin/review-requests/stats', { params: { scope } });
}

export function approveReviewRequest(id: number | string) {
  return post<{ message: string; reviewRequestId: number }>(`/admin/review-requests/${id}/approve`);
}

export function rejectReviewRequest(id: number | string, reason: string) {
  return post<{ message: string; reviewRequestId: number }>(`/admin/review-requests/${id}/reject`, { reason });
}
